<template>
    <v-card flat class="mt-2">
        <v-form class="multi-col-validation">
            <v-card-title>Universitas</v-card-title>
            <v-card-text class="">
                <v-row>
                    <v-col cols="6" md="3">
                        <v-text-field v-model="userSelected.username" label="Username :" dense outlined readonly></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-text-field v-model="userSelected.email" label="Email :" dense outlined readonly></v-text-field>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-autocomplete v-model="userSelected.id_institusi" :items="institusi_pendidikans" outlined dense
                            label="Institusi Pendidikan :" item-text="nama" item-value="id"></v-autocomplete>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-text-field v-model="userSelected.no_hp" label="No Handphone :" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="userSelected.alamat" label="Alamat :" dense outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
import axios from 'axios'
import UploadDokumenRegistrasi from '@/components/upload/UploadDokumenRegistrasi.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        UploadDokumenRegistrasi,
    },
    data: () => ({
        dokter: {
            username: '',
            email: '',
            // nama: '',
            // nim: '',
            id_institusi: '',
            // prodi: '',
            // jenis_kelamin: '',
            alamat: '',
            no_hp: '',
            // dokumen: [
            //     'surat_pengantar',
            //     'ijazah',
            //     'sertifikat_vaksin',
            //     'pas_foto',
            // ]
        },
        institusi_pendidikans: [],
        prodis: [],
    }),
    computed: {
        headers() {
            return {
                Authorization: this.$store.state.token,
            }
        },
        userSelected() {
            return this.$store.getters.userSelected
        },
    },
    watch: {
        userSelected: function () {
            this.getInstitusiPendidikan()
        }
    },
    created() {
        this.getInstitusiPendidikan()
    },
    methods: {
        getInstitusiPendidikan() {
            const headers = this.headers
            axios
                .get(`${apiRoot}/api/RegisterLanjutan/getInstitusiPendidikans`, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.institusi_pendidikans = response.data.datas
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
    },
}
</script>